webpackJsonp([1],{

/***/ "+skl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4G6+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5AoB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signaturePadBig_vue__ = __webpack_require__("QLmk");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f21185a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_signaturePadBig_vue__ = __webpack_require__("JUv6");
function injectStyle (ssrContext) {
  __webpack_require__("tsSR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signaturePadBig_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f21185a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_signaturePadBig_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "E97b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phonedraw_vue__ = __webpack_require__("iRAr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_024849ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phonedraw_vue__ = __webpack_require__("s4BW");
function injectStyle (ssrContext) {
  __webpack_require__("4G6+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phonedraw_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_024849ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phonedraw_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_request_js__ = __webpack_require__("dZpa");




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    index: '/index',
    islogin: true
  },
  mutations: {
    changeHead: function changeHead(state, payload) {
      state.index = payload.index;
    },
    login: function login(state, payload) {
      state.islogin = payload.islogin;
    }
  },
  actions: {
    changeHead: function changeHead(context, payload) {
      context.commit('changeHead', { index: payload.index });
    },
    login: function login(context, user) {
      return __WEBPACK_IMPORTED_MODULE_2__components_request_js__["a" /* default */].post('unchk/login/index', user).then(function (res) {
        if (res.data.code === 20) {
          context.commit('login', { islogin: true });
          return res.data;
        } else {
          return res.data;
        }
      });
    }
  }
}));

/***/ }),

/***/ "JUv6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('view',[_c('u-popup',{attrs:{"mask-close-able":false,"border-radius":"10","mode":"center","z-index":"40","width":"500rpx","height":"250rpx"},model:{value:(_vm.uploadShow),callback:function ($$v) {_vm.uploadShow=$$v},expression:"uploadShow"}},[_c('canvas',{staticClass:"mycanvas",attrs:{"canvas-id":"mycanvas"},on:{"touchstart":_vm.touchstart,"touchmove":_vm.touchmove,"touchend":_vm.touchend}}),_vm._v(" "),_c('view',{staticClass:"footer"},[_c('view',{staticClass:"left",staticStyle:{"width":"25%"},on:{"click":_vm.clear}},[_vm._v("清除")]),_vm._v(" "),_c('button',{staticClass:"left",staticStyle:{"width":"25%"},attrs:{"disabled":_vm.isSubmitting},on:{"click":_vm.finish}},[_vm._v(_vm._s(_vm.isSubmitting ? '提交中...' : '提交'))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b3fac85_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("MPz9");
function injectStyle (ssrContext) {
  __webpack_require__("fZTc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b3fac85_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MPz9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('meta',{attrs:{"charset":"utf-8","name":"viewport","content":"width=device-width, initial-scale=1.0, user-scalable=no, minimum-scale=1.0, maximum-scale=1.0"}}),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_index_css__ = __webpack_require__("tvR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_iview__ = __webpack_require__("BTaQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_iview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_iview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_iview_dist_styles_iview_css__ = __webpack_require__("+skl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_iview_dist_styles_iview_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_iview_dist_styles_iview_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_cookie__ = __webpack_require__("K/Lq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_cookie__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.











__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('time', function (value, formatString) {
  formatString = formatString || 'YYYY-MM-DD HH:mm';
  return __WEBPACK_IMPORTED_MODULE_6_moment___default()(value).format(formatString);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_iview___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "QLmk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_request__ = __webpack_require__("dZpa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cookie__ = __webpack_require__("K/Lq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_cookie__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var x = 20;
var y = 20;
/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			ctx: '', //绘图图像
			points: [], //路径点集合 
			isEnd: false, // 是否结束签名
			uploadShow: true,
			recordId: '',
			drawWidth: '',
			drawHeight: '',
			isSubmitting: true
		};
	},

	/* 		onLoad(op) {
 			//			this.recordId = op.recordId
 			let that = this
 			uni.getSystemInfo({
 				success: function(res) {
 					that.drawWidth = res.screenWidth;
 					that.drawHeight = res.screenHeight * 0.8;
 				},
 			})
 			}, */
	created: function created() {
		this.screenWidth = screen.availWidth;
		this.screenHeight = screen.availHeight;
		this.ctx = uni.createCanvasContext("mycanvas", this); //创建绘图对象

		//设置画笔样式
		this.ctx.lineWidth = 8;
		this.ctx.lineCap = "round";
		this.ctx.lineJoin = "round";
		this.ctx.fillStyle = "#ffffff";
		this.ctx.fillRect(0, 0, this.drawWidth, this.drawHeight);
	},

	methods: {
		//触摸开始，获取到起点
		touchstart: function touchstart(e) {
			var startX = e.changedTouches[0].x;
			var startY = e.changedTouches[0].y;
			var startPoint = {
				X: startX,
				Y: startY
			};
			this.points.push(startPoint);
			//每次触摸开始，开启新的路径
			this.ctx.beginPath();
		},

		//触摸移动，获取到路径点
		touchmove: function touchmove(e) {
			var moveX = e.changedTouches[0].x;
			var moveY = e.changedTouches[0].y;
			var movePoint = {
				X: moveX,
				Y: moveY
			};
			this.points.push(movePoint); //存点
			var len = this.points.length;
			if (len >= 2) {
				this.draw(); //绘制路径
			}
		},

		// 触摸结束，将未绘制的点清空防止对后续路径产生干扰
		touchend: function touchend() {
			this.points = [];
			this.isEnd = true;
		},

		/* ***********************************************
  #   绘制笔迹
  #	1.为保证笔迹实时显示，必须在移动的同时绘制笔迹
  #	2.为保证笔迹连续，每次从路径集合中区两个点作为起点（moveTo）和终点(lineTo)
  #	3.将上一次的终点作为下一次绘制的起点（即清除第一个点）
  ************************************************ */
		draw: function draw() {
			var point1 = this.points[0];
			var point2 = this.points[1];
			this.points.shift();
			this.ctx.moveTo(point1.X, point1.Y);
			this.ctx.lineTo(point2.X, point2.Y);
			this.ctx.stroke();
			this.ctx.draw(true);
		},

		//清空画布
		clear: function clear() {
			var that = this;
			uni.getSystemInfo({
				success: function success(res) {
					debugger;
					var canvasw = res.windowWidth;
					var canvash = res.windowHeight;
					that.ctx.clearRect(0, 0, canvasw, canvash);
					that.ctx.draw(true);
				}
			});
		},

		//完成绘画并保存到本地
		/* 			finish: function() {
  				let that = this
  				let data = {
  					recordId: that.recordId,
  					type: 2,
  					userId: that.loginInfo.userId
  				}
  				console.log(data)
  				if (!this.isEnd) {
  					uni.showToast({
  						title: '请先完成签名',
  						icon: "none",
  						duration: 1500,
  						mask: true
  					})
  					return
  				}
  					uni.canvasToTempFilePath({
  					canvasId: 'mycanvas',
  					width: this.drawWidth,
  					height: this.drawHeight,
  					destWidth: 500,
  					destHeight: 250,
  					success: function(res) {
  						let path = res.tempFilePath;
  						uni.saveImageToPhotosAlbum({
  							filePath: path,
  							success: function(su) {
  								uni.uploadFile({
  									url: BASE_URL +
  										'DilimsUploadServlet', //开发者服务器 url
  									header: {
  										// HTTP 请求 Header, header 中不能设置 Referer
  									},
  									filePath: path, // 要上传文件资源的路径
  									name: 'fileblock', // 文件对应的 key , 开发者在服务器端通过这个 key 可以获取到文件二进制内容
  									formData: {
  										// HTTP 请求中其他额外的 form data （即接口需要的其它参数）
  										recordId: that.recordId,
  										type: 2,
  										userId: that.loginInfo.userId
  									},
  									success(uploadFileRes) {
  										let data = JSON.parse(uploadFileRes.data)
  										that.$utils.toast(data.resultMessage)
  										setTimeout(() => {
  											uni.navigateBack({
  												delta: 1
  											})
  										}, 500)
  									}
  								})
  							}
  						});
  					}
  				})
  			}, */
		// 生成图片
		finish: function finish() {
			debugger;
			this.isSubmitting = true;
			var canvas = document.querySelector('#mycanvas');
			var src = canvas.toDataURL('image/png');
			var pic = src;
			var id = null;
			var url = window.location.href;
			var queryParams = this.getQueryParams(url);
			this.userName = queryParams.userName;
			this.userId = queryParams.userId;
			this.billProjectId = queryParams.billProjectId;
			__WEBPACK_IMPORTED_MODULE_0__components_request__["a" /* default */].post('upload', {
				base64: pic,
				userId: that.userId,
				billProjectId: that.billProjectId
			}).then(function (res) {
				if (res.data.status === 20) {
					alert('绘制成功,请到pc端查看');
					window.opener = null;
					window.close();
				}
			}).catch(function (err) {
				alert(err);
			}).finally(function () {
				// this.isSubmitting = false;
			});
		}
	}
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_phonedraw__ = __webpack_require__("E97b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_signaturePadBig__ = __webpack_require__("5AoB");






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	mode: 'history',
	routes: [{
		path: '/',
		component: __WEBPACK_IMPORTED_MODULE_3__pages_phonedraw__["a" /* default */],
		children: [
			// {
			// 	path: '/sign',
			// 	component: Sign,
			// 	name: 'sign'
			// },
			// 	{
			// 		path: '/qrcode',
			// 		component: Qrcode,
			// 		name: 'qrcode'
			// 	},
			// 	{
			// 		path: '/phone',
			// 		component: Phone,
			// 		name: 'phone'
			// 	}
		]
	}]
}));

/***/ }),

/***/ "dZpa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie__ = __webpack_require__("K/Lq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_cookie__);




// 添加请求拦截器
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  return config;
}, function (error) {
  // 对请求错误做些什么
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

// 添加响应拦截器
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  return response;
}, function (error) {
  // 对响应错误做点什么
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = ({
  post: function post(url, data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'post',
      // baseURL: 'http://192.168.3.35:8000/DILIMS/sign',
      // baseURL: 'https://bz.yydilims.com//DILIMS/sign',
      baseURL: 'http://8.137.126.10:8000/DILIMS/sign',
      url: url,
      data: data,
      timeout: 20000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json; charset=UTF-8',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': true
      }
    }).then(function (response) {
      if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
        return response;
        // 如果不需要除了data之外的数据，可以直接 return response.data
      }
      __WEBPACK_IMPORTED_MODULE_2_element_ui___default.a.Message('网络异常');
    });
  }
});

/***/ }),

/***/ "fZTc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iRAr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_request__ = __webpack_require__("dZpa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie__ = __webpack_require__("K/Lq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_cookie__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			userName: '张三',
			userId: '',
			billProjectId: '',
			context: {},
			imgUrl: [],
			canvasMoveUse: true,
			// 存储当前表面状态数组-上一步
			preDrawAry: [],
			// 存储当前表面状态数组-下一步
			nextDrawAry: [],
			// 中间数组
			middleAry: [],
			// 配置参数
			config: {
				lineWidth: 10,
				lineColor: '#000000',
				shadowBlur: 1
			},
			isEnd: false, // 是否结束签名
			screenWidth: null,
			screenHeight: null,
			ctx: '', //绘图图像
			points: [], //路径点集合 
			drawWidth: '',
			drawHeight: '',
			isSubmitting: false,
			bgColor: '#409eff',
			imageWidth: 570,
			imageHeight: 285
		};
	},
	created: function created() {
		this.screenWidth = screen.availWidth;
		this.screenHeight = screen.availHeight * 0.81;
		var url = window.location.href;
		var queryParams = this.getQueryParams(url);
		this.userName = queryParams.userName;
		this.userId = queryParams.userId;
		this.billProjectId = queryParams.billProjectId;
	},
	mounted: function mounted() {
		var canvas = document.querySelector('#canvas');
		this.context = canvas.getContext('2d');
		this.context.imageSmoothingEnabled = false;
		this.context.imageSmoothingQuality = 'low';
		this.context.translate(0.5, 0.5);
		// this.context.fillRect(0, 0, this.screenWidth, this.screenHeight);
		this.context.stroke();
		this.initDraw();
		this.setCanvasStyle();
	},

	watch: {
		screenWidth: function screenWidth(val) {
			this.screenWidth = val;
		}
	},
	methods: {
		isPc: function isPc() {
			var userAgentInfo = navigator.userAgent;
			var Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
			var flag = true;
			for (var v = 0; v < Agents.length; v++) {
				if (userAgentInfo.indexOf(Agents[v]) > 0) {
					flag = false;
					break;
				}
			}
			return flag;
		},
		removeImg: function removeImg(src) {
			this.imgUrl = this.imgUrl.filter(function (item) {
				return item !== src;
			});
		},
		initDraw: function initDraw() {
			var preData = this.context.getImageData(0, 0, this.imageWidth, this.imageHeight);
			// 空绘图表面进栈
			this.middleAry.push(preData);
		},
		canvasMove: function canvasMove(e) {
			if (this.canvasMoveUse) {
				console.log('canvasMove');
				var t = e.target;
				var canvasX = void 0;
				var canvasY = void 0;
				if (this.isPc()) {
					canvasX = e.clientX - t.parentNode.offsetLeft;
					canvasY = e.clientY - t.parentNode.offsetTop;
				} else {
					canvasX = e.changedTouches[0].clientX - t.parentNode.offsetLeft;
					canvasY = e.changedTouches[0].clientY - t.parentNode.offsetTop;
				}
				this.context.lineTo(canvasX, canvasY);
				this.context.stroke();
			}
		},
		beginPath: function beginPath(e) {
			var canvas = document.querySelector('#canvas');
			if (e.target !== canvas) {
				console.log('beginPath');
				this.context.beginPath();
			}
		},

		// mouseup
		canvasUp: function canvasUp(e) {
			console.log('canvasUp');
			var preData = this.context.getImageData(0, 0, this.imageWidth, this.imageHeight);
			if (!this.nextDrawAry.length) {
				// 当前绘图表面进栈
				this.middleAry.push(preData);
			} else {
				this.middleAry = [];
				this.middleAry = this.middleAry.concat(this.preDrawAry);
				this.middleAry.push(preData);
				this.nextDrawAry = [];
			}
			this.canvasMoveUse = false;
			this.isEnd = true;
		},

		// mousedown
		canvasDown: function canvasDown(e) {
			console.log('canvasDown');
			this.canvasMoveUse = true;
			// client是基于整个页面的坐标
			// offset是cavas距离顶部以及左边的距离
			var canvasX = e.clientX - e.target.parentNode.offsetLeft;
			var canvasY = e.clientY - e.target.parentNode.offsetTop;
			this.setCanvasStyle();
			// 清除子路径
			this.context.beginPath();
			this.context.moveTo(canvasX, canvasY);
			console.log('moveTo', canvasX, canvasY);
			// 当前绘图表面状态
			var preData = this.context.getImageData(0, 0, this.imageWidth, this.imageHeight);
			// 当前绘图表面进栈
			this.preDrawAry.push(preData);
			e.preventDefault();
		},

		//      // 设置颜色
		//      setColor(color) {
		//        this.config.lineColor = color
		//      },
		// 设置笔刷大小
		setBrush: function setBrush(type) {
			this.config.lineWidth = type;
		},

		// 操作
		controlCanvas: function controlCanvas(action) {
			switch (action) {
				case 'clear':
					this.context.clearRect(0, 0, this.context.canvas.width, this.context.canvas.height);
					this.preDrawAry = [];
					this.nextDrawAry = [];
					this.middleAry = [this.middleAry[0]];
					this.isEnd = false;
					break;
			}
		},

		// 生成图片
		getImage: function getImage() {
			var _this = this;

			if (!this.userId) {
				alert('用户Id为空，无法进行保存');
				return;
			}
			if (!this.billProjectId) {
				alert('委托单Id为空，无法进行保存');
				return;
			}
			if (!this.isEnd) {
				alert('请先完成签名');
				return;
			}
			debugger;
			if (this.isSubmitting) {
				alert('正在提交中，请稍等。。。');
				return;
			}
			this.isSubmitting = true;
			this.bgColor = '#a2a2a2';
			var canvas = document.querySelector('#canvas');
			var src = canvas.toDataURL('image/png');
			var pic = src;
			var that = this;
			__WEBPACK_IMPORTED_MODULE_2__components_request__["a" /* default */].post('upload', {
				base64: pic,
				userId: that.userId,
				billProjectId: that.billProjectId
			}).then(function (res) {
				debugger;
				if (res.data.status === '20') {
					alert('绘制成功');
				} else {
					alert(res.data.errMsg);
				}
				_this.isSubmitting = false;
				_this.bgColor = '#409eff';
			}).catch(function (err) {
				alert(err);
			});
		},
		showToast: function showToast(message, type) {
			this.$refs.toast.show(message, type);
		},

		// 设置绘画配置
		setCanvasStyle: function setCanvasStyle() {
			this.context.lineWidth = this.config.lineWidth;
			this.context.shadowBlur = this.config.shadowBlur;
			this.context.lineColor = this.config.lineColor;
		},
		getViewportSize: function getViewportSize() {
			return {
				width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
				height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
			};
		},

		// 解析url参数
		getQueryParams: function getQueryParams(url) {
			// 创建一个新的URL对象
			var urlObj = new URL(url);
			// 使用URLSearchParams获取查询参数
			var params = new URLSearchParams(urlObj.search);
			// 将所有参数转换为一个对象
			var queryParams = {};
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(params), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var _ref = _step.value;

					var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

					var key = _ref2[0];
					var value = _ref2[1];

					queryParams[key] = value;
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			return queryParams;
		}
	}

});

/***/ }),

/***/ "s4BW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inner draw",on:{"mousemove":function($event){_vm.beginPath($event)}}},[_c('div',{staticClass:"wrap",staticStyle:{"position":"relative"}},[_c('canvas',{staticClass:"fl",staticStyle:{"image-rendering":"pixelated"},attrs:{"id":"canvas","width":_vm.screenWidth,"height":_vm.screenHeight},on:{"mousedown":function($event){_vm.canvasDown($event)},"mouseup":function($event){_vm.canvasUp($event)},"mousemove":function($event){_vm.canvasMove($event)},"touchstart":function($event){_vm.canvasDown($event)},"touchend":function($event){_vm.canvasUp($event)},"touchmove":function($event){_vm.canvasMove($event)}}}),_vm._v(" "),_c('div',{staticStyle:{"float":"left"},attrs:{"id":"tip"}},[_c('h4',{staticClass:"tips"},[_vm._v("当前签名人 # "+_vm._s(_vm.userName))])]),_vm._v(" "),_c('div',{staticStyle:{"float":"left"},attrs:{"id":"control"}},[_c('div',{attrs:{"id":"canvas-control"}},[_c('button',{staticClass:"el-button btn-orange el-button--primary",on:{"click":function($event){_vm.controlCanvas('clear')}}},[_vm._v("\n\t\t\t\t\t清除\n\t\t\t\t")]),_vm._v(" "),_c('button',{staticClass:"el-button btn-orange el-button--primary",style:({ backgroundColor: _vm.bgColor }),on:{"click":_vm.getImage}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.isSubmitting ? '提交中...' : '提交')+"\n\t\t\t\t")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tsSR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  created: function created() {},

  methods: {}
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.a12d8a070a998635b0d1.js